'use client'

import React, { useState } from 'react'

import { useQuery } from '@apollo/client'

import { JoinUsNowModal } from 'Components/Blocks/Modals'
import {
  EmajinCorporateMembershipPackagesSection,
  ExploreCorporateMembershipSection,
  ExploreOurMembershipsSection,
  FAQSection,
  MembershipPointsSection,
  MembershipsHeroSection,
  TeeOffCorporateMembershipPackagesSection,
} from 'Components/Sections'
import { Column, Loader } from 'Components/UI'
import { APOLLO_CLIENT_CONTEXT_ID } from 'Config/apolloClient'

import {
  AllMembershipFeaturesDocument,
  MembershipFeatureModelOrderBy,
  MembershipsPageDocument,
} from 'GraphQL/DatoCMS/TypedDocuments'

function MembershipsPage() {
  const [joinUsModalModalOpened, setJoinUsModalModalOpened] = useState(false)

  const { data: membershipsPageData, loading } = useQuery(
    MembershipsPageDocument,
    {
      context: { [APOLLO_CLIENT_CONTEXT_ID.Dato]: true },
    },
  )

  const { data: allMembershipFeaturesData } = useQuery(
    AllMembershipFeaturesDocument,
    {
      variables: {
        orderBy: [MembershipFeatureModelOrderBy.PriorityAsc],
      },
      context: { [APOLLO_CLIENT_CONTEXT_ID.Dato]: true },
    },
  )

  if (loading) return <Loader fullScreen size={32} />

  return (
    <Column alignCenter fullWidth>
      <MembershipsHeroSection
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <ExploreOurMembershipsSection />

      <EmajinCorporateMembershipPackagesSection
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <MembershipPointsSection
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <TeeOffCorporateMembershipPackagesSection
        features={allMembershipFeaturesData?.allMembershipFeatures}
        packages={membershipsPageData?.membershipsPage?.membershipPackages}
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <ExploreCorporateMembershipSection />

      <FAQSection data={membershipsPageData?.membershipsPage?.faq} />

      <JoinUsNowModal
        isOpened={joinUsModalModalOpened}
        onClose={() => setJoinUsModalModalOpened(false)}
      />
    </Column>
  )
}

export default MembershipsPage
